import { mlEntries, LANG_LABELS } from "@/lib/ml";

/**
 * Renders a multilingual text value ({en: "...", hi: "..."} or a plain string).
 * English (or the first written language) leads; every other written language
 * is shown beneath it with a small label, so the whole family — and admins
 * checking for corrections — can see every version at a glance.
 */
export default function MultilingualText({ value, className = "", quoted = false, testid }) {
  const entries = mlEntries(value);
  if (!entries.length) return null;

  const sorted = [...entries].sort((a, b) => (a[0] === "en" ? -1 : b[0] === "en" ? 1 : 0));

  if (sorted.length === 1) {
    const text = sorted[0][1].trim();
    return (
      <p className={className} data-testid={testid} lang={sorted[0][0]}>
        {quoted ? `"${text}"` : text}
      </p>
    );
  }

  return (
    <div className={className} data-testid={testid}>
      {sorted.map(([code, text], i) => (
        <p key={code} lang={code} className={i > 0 ? "mt-2" : undefined}>
          <span className="not-italic mr-2 inline-block border border-[color:var(--sepia)]/40 px-1.5 py-px font-heritage-caps text-[9px] tracking-[0.14em] text-[color:var(--sepia)] align-middle">
            {LANG_LABELS[code] || code.toUpperCase()}
          </span>
          {quoted ? `"${text.trim()}"` : text}
        </p>
      ))}
    </div>
  );
}
